module.exports = "pegasus_template/assets/themelp1/small/0.png";